
import TeaserCard from '../teaser-card/teaser-card';

export default class TeaserCardWithLinks extends TeaserCard {

}
